<!--
    班级管理-上课日志
    功能：展示班级上课日志列表
    说明：旧版本
-->
<template>
  <div class="log">
    <AppList
      v-if="activeName === 'first'"
      ref="list_live"
      :list.sync="list"
      :columns="columnsAll"
      :columns-check="columns"
      title=""
      api="/api/liveroom"
      api-type="/api/liveroom?is_show_teacher=1&order[created_at]=desc"
      @checkedColumns="checkedColumns">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"
        date-type="search"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="80px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <template
                v-if="$permissions('school_statistics_log_info')"
              >
                <el-link
                  v-if="$store.state.from === 'schoolCenter'"
                  @click="StatisticalClass(scope.row)"
                >详情</el-link>
                <el-button
                  v-else
                  size="small"
                  @click="StatisticalClass(scope.row)"
                >详情</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
  </div>
</template>

<script>
import list from '@/mixins/list';

export default {
  name: 'Log',
  mixins: [list],
  data() {
    return {
      id: this.$route.params.id,
      activeName: 'first',
      list: {},
      columnsAll: [
        {
          index: 0,
          label: '直播时间',
          width: '180px',
          formatter: (row) => {
            let time = '';
            switch (row.status) {
              case 1: // 未开始 展示预设直播开始时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 2: // 直播中 展示实际直播开始时间~--
                time = `${row.begin_time} ~ --`;
                break;
              case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                time = `${row.begin_time} ~ ${row.close_time}`;
                break;
              case 4: // 缺课 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 5: // 已取消 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              default:
                break;
            }
            return time;
          },
        },
        {
          index: 1,
          label: '直播时长',
          formatter: (row) => {
            const time = this.$setting.setTime(row.act_liveroom_second);
            return `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
          },
        },
        { index: 2, prop: 'name', label: '课题' },
        { index: 3, prop: 'teacher.name', label: '授课老师' },
        { index: 4, prop: 'number', label: '教室编号' },
        {
          index: 5,
          label: '直播类型',
          formatter: (row) => {
            const type = {
              1: '班级直播间',
              2: '链接直播间',
              3: '线下课',
            };
            return type[row.type];
          },
        },
        {
          index: 6,
          label: '直播状态',
          formatter: (row) => {
            const status = {
              1: '未开始',
              2: '直播中',
              3: '已结束',
              4: '缺课',
              5: '已取消',
            };
            return status[row.status];
          },
        },
        {
          index: 7,
          label: '授课班型',
          formatter: (row) => {
            const type = {
              1: '1v1',
              2: '1v4',
              3: '1v6',
            };
            return type[row.video_type];
          },
        },
        {
          index: 8,
          label: '选课类型',
          prop: 'course_type_text',
          /* formatter: row => {
            const type = {
              1: 'AI课件',
              2: 'AI双师课件',
              3: '互动课件',
              4: '其他',
              0: '其他'
            };
            return type[row.course_type]
          } */
        },
        { index: 9, prop: 'course_name', label: '课时名称' },
        { index: 10, prop: 'bill_course_amount', label: '消费金币' },
        { index: 11, prop: 'student_count', label: '上课总人次' },
        { index: 12, prop: 'teacher.mobile', label: '手机号' },
        { index: 13, prop: 'bill_teaching_amount', label: '直播消费金额' },
        { index: 14, prop: 'student_count', label: '学生数' },
        {
          index: 15,
          label: '是否录制',
          formatter: row => (row.is_playback === 1 ? '是' : '否'),
        },
      ],
      columns: [],
    };
  },
  computed: {
    searchArr() { // 搜索条件
      const column = [
        { prop: 'name', label: '课题名称' },
        { prop: 'teacher_name', label: '授课老师' },
        { prop: 'teacher_mobile', label: '手机号' },
        { prop: 'number', label: '教室编号' },
      ];
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        {
          selectValue: [
            { value: 2, name: '直播中' },
            { value: 1, name: '未开始' },
            { value: 3, name: '已结束' },
            { value: 4, name: '老师缺席' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'status',
          placeholder: '请选择直播状态',
        },
        {
          selectValue: [
            { value: 1, name: '班级直播' },
            { value: 2, name: '链接直播' },
            { value: 3, name: '线下课' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'type',
          placeholder: '请选择直播类型',
        },
        {
          selectValue: [
            { value: 1, name: 'AI课件' },
            { value: 2, name: 'AI双师课件' },
            { value: 3, name: '互动课件' },
            { value: 4, name: '其他' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'course_type',
          placeholder: '请选择选课类型',
        },
        // {
        //   selectValue: [ // 缺少
        //     { value: 0, name: '互动课件' },
        //     { value: 1, name: '云盘文件' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_auth_minipro',
        //   placeholder: '请选择课件类型'
        // },
        // {
        //   selectValue: [
        //     { value: 1, name: '是' },
        //     { value: 0, name: '否' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_playback',
        //   placeholder: '请选择录制情况'
        // },
        // {
        //   selectValue: [ // 缺少
        //     { value: 0, name: '是' },
        //     { value: 1, name: '否' }
        //   ],
        //   componentType: 'AppSearchStatus',
        //   searchType: 'is_auth_minipro',
        //   placeholder: '请选择回放情况'
        // },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    role() {
      return this.$store.state.user;
    },
  },
  created() {
    const initColumn = [];
    const indexOff = [12, 13, 14, 15];
    this.columnsAll.forEach((item) => {
      if (indexOff.indexOf(item.index) === -1) {
        initColumn.push(item);
      }
    });
    this.columns = initColumn;
  },
  methods: {
    timeFamate(num) {
      return num > 9 ? num : `0${num}`;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 确认授权
    onSubmit() {
      console.log(1);
    },
    // 选择列表字段
    checkedColumns(val) {
      const data = [];
      val.forEach((item) => {
        this.columnsAll.forEach((v) => {
          if (v.label === item) {
            data.push(v);
          }
        });
      });
      data.sort((a, b) => a.index - b.index);
      this.$nextTick(() => {
        this.columns = data;
      });
    },
    // 上课统计详情
    StatisticalClass(row) {
      localStorage.setItem('liveroom_action', JSON.stringify(row));
      this.$router.push(`/classlog/detail/${row.id}`);
    },
  },
};
</script>

<style scoped lang="scss">
  .log {
    .total {
      text-align: right;
      font-size: 16px;
      color: var(--color-primary);
      span {
        margin: 0 10px;
        b {
          margin: 0 5px;
        }
      }
    }
  }
</style>
<style lang="scss">
  .log {
    .app-search-status {
      max-width: 140px;
      .el-select {
        max-width: 140px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ClassLog/index.vue